export default __webpack_public_path__ + "static/media/R100.6757ebd4.gif";